export const TAB = {
    PERMISSION: 1,
    ROLE: 0,
};

export const ORGANIZATION = {
    SYSTEM: 0
}

export const STATUS = {
    ACTIVE: 1,
    DISABLE: 0,
    ALL: 3
}